import { ReactNode, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export type NavigationItem = {
  title: string;
  id: number;
  url?: string;
  icon?: ReactNode;
  subItems?: NavigationItem[];
};

type NavigationItemsProps = {
  items: NavigationItem[];
  isShowing?: boolean;
  // setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  handleCloseModal?: (clicked: boolean, option: string) => void;
};

export const NavigationItems = ({
  items,
  isShowing = true,
  handleCloseModal
}: NavigationItemsProps) => {
  const location = useLocation();

  const [expandedItems, setExpandedItems] = useState<number[]>([]);

  const toggleExpansion = (itemId: number) => {
    if (expandedItems.includes(itemId)) {
      setExpandedItems(expandedItems.filter((id) => id !== itemId));
    } else {
      setExpandedItems([...expandedItems, itemId]);
    }
  };

  return (
    <ul className={`${isShowing ? 'tw-block' : 'tw-hidden'}  `}>
      {items.map((item) => (
        <li key={item.id}>
          <Link
            to={item.url || '#'}
            className={`${
              location.pathname === item.url
                ? 'tw-bg-[#e9edf4] tw-text-[#146CFA] tw-font-bold'
                : 'tw-text-[#001E64]'
            } tw-pl-4 tw-block tw-transition-opacity hover:tw-opacity-80`}
            onClick={() => {
              handleCloseModal && handleCloseModal(true, item.title);
              if (item.subItems) {
                toggleExpansion(item.id);
              }
            }}
          >
            <div className="tw-h-[3.25rem] tw-text-sm tw-flex tw-justify-between">
              <div className="tw-flex tw-gap-4 tw-items-center">
                {item.icon ? item.icon : null}
                {item.title}
              </div>
              {location.pathname === item.url ? (
                <div className="tw-border-r-4 tw-border-blue-500 tw-rounded-l-md tw-w-[0.3125rem] tw-h-full" />
              ) : null}
            </div>
          </Link>

          {item.subItems && expandedItems.includes(item.id) && (
            <ul className="tw-pl-6">
              {item.subItems.map((subItem) => (
                <li
                  key={subItem.id}
                  className={`${
                    location.pathname === item.url
                      ? 'tw-bg-[#146CFA] tw-text-[#146CFA]'
                      : 'tw-text-[#001E64]'
                  } tw-px-4 tw-py-2 tw-transition-opacity hover:tw-opacity-80`}
                >
                  <Link to={subItem.url || '#'} className="tw-block">
                    <div className="tw-h-[3.25rem] tw-text-xs tw-flex tw-gap-2 tw-items-center">
                      {subItem.title}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};
